import { useEffect, useRef } from 'react';

/**
 * AnimatedSection — wraps children with IntersectionObserver fade-up animation.
 * Children with class "animate-child" get staggered delay.
 */
export default function AnimatedSection({ children, className = '', delay = 0 }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Stagger children
            const children = el.querySelectorAll('.animate-child');
            if (children.length > 0) {
              children.forEach((child, i) => {
                child.style.transitionDelay = `${delay + i * 0.1}s`;
                child.classList.add('visible');
              });
            }
            el.classList.add('visible');
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);

  return (
    <div
      ref={ref}
      className={`animate-fade-up ${className}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      {children}
    </div>
  );
}
